import React from 'react';

const ChatMessage = ({ message, onSpeak, isSpeaking }) => {
  const handleSpeak = () => {
    if (message.type === 'ai' && !isSpeaking) {
      onSpeak(message.content);
    }
  };

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div
      style={{
        maxWidth: '500px',
        padding: '1rem',
        borderRadius: '16px',
        position: 'relative',
        ...(message.type === 'user' ? {
          background: 'linear-gradient(135deg, #667eea, #764ba2)',
          color: 'white',
          marginLeft: 'auto',
          borderBottomRightRadius: '4px'
        } : {
          background: '#f3f4f6',
          color: '#1f2937',
          marginRight: 'auto',
          borderBottomLeftRadius: '4px',
          border: '1px solid #e5e7eb'
        })
      }}
    >
      <div style={{ marginBottom: '0.25rem' }}>
        {message.content}
      </div>
      
      <div style={{ fontSize: '0.75rem', opacity: 0.7, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span>{formatTime(message.timestamp)}</span>
        
        {message.type === 'ai' && (
          <button
            onClick={handleSpeak}
            disabled={isSpeaking}
            style={{
              marginLeft: '0.5rem',
              padding: '0.25rem',
              borderRadius: '50%',
              background: isSpeaking ? '#d1fae5' : 'transparent',
              color: isSpeaking ? '#10b981' : '#6b7280',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            title="Reproducir mensaje"
          >
            {isSpeaking ? '🔊' : '🔈'}
          </button>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;